<template>
	<div id="Bigcoffeegatheringdetails" class="centert">
		<!-- 头标签 -->
		<dpubtop></dpubtop>
		<!-- 中间 -->
		<div class="Bigcoffdetails">
			<!-- 头部 -->
			<div class="pub_pub">
				<div class="pub_title">
					<div class="img_logo">
						<img src="../../../imges/lebiao/zjzk.png" alt="">
					</div>
					<div class="title_t">
						<div class="imhg_ti">
							<img src="../../../imges/lebiao/zjzk_font.png" alt="">
						</div>
						<div class="sm_t">
							<div style="float:left"><span>会员</span><span style="color:#D7230C;">活动</span></div>
							<div class="sm_pub">精彩会员活动</div>
						</div>
					</div>
				</div>
				<div style="width: 0px;height: 36px;border: 1px solid #ececec;float: left;">
					<!-- 中间线 -->
				</div>
				<div class="ckgd_dh">
					<div class="sy">
						<div class="sy_img">
							<img src="../../../imges/details/sy.png" alt="">
						</div>
						<router-link class="sy_title" to="/" style="text-decoration: none;
							">首页</router-link>
					</div>
					<div class="jt" style="margin-top: 0px;">
						<img src="../../../imges/details/jt.png" alt="">
					</div>
					<div class="name">会员活动</div>
				</div>
				<div style="width: 80px;height: 36px;float: left;line-height: 40px;margin-left: 50px;font-size: 14px;text-align: center;">
					关键词：
				</div>
				<div class="Bigcosousuo" style="margin-left: 0px;">
					<input v-model="keyword" type="text" placeholder="请输入内容">
					<div @click="selectChild1">
						搜索
					</div>
				</div>
			</div>
			<!-- 头部结束 -->
			<div class="top_bottom">
				<div style="width: 95%;margin: 0 auto;height: 1050px;">
					<router-link tag="div" v-for="(item,index) in dataList" :key="index"
						style="width: 24%;height: 250px;margin-left: 0.8%;float: left;margin-top: 15px;box-shadow: #6e6e6e 0px 0px 10px;"
						class="NewArrialsb"
						:to="{path: '/hyhddetail', query: {id:item.id,title:item.title}}">
						<div style="height: 190px;">
							<img v-lazy="item.picture" style="width: 100%;height: 100%;" alt="">
						</div>
						<div style="height: 20px;text-align: center;line-height: 20px;font-weight: 700;font-size: 14px; overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;">
							{{item.title}}
						</div>
						<div
							style="height: 30px;text-align: center;line-height: 30px;font-weight: 700;font-size: 14px;color: crimson;width: 40%;margin: 0 auto;border: 1px solid #D7230C;border-radius: 5px;margin-top: 5px;">
							查看详情
						</div>
					</router-link>
				</div>
				<!-- 分页 -->
				<div style="height: 40px;text-align: center;margin-top: 55px;">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page.sync="currentPage" :page-size="PageSize" layout="total, prev, pager, next"
						:total="Totals">
					</el-pagination>
				</div>
			</div>


		</div>
		<!-- 中间结束 -->
		<!-- 尾标签 -->
		<myfooter></myfooter>
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				dataLists: '',
				currentPage: 1, //当前页
				PageSize: 12, //当前每页数据
				Totals: 100, //总数据条数
				keyword: '', //搜索框查询关键字
				dataList: [],
			}
		},
		components: {
			// 尾标签,
			myfooter: resolve => require(['@/components/myfooter'], resolve),
			// 头标签
			dpubtop: resolve => require(['@/components/dpubtop/dpubtop'], resolve),
		},
		async mounted() {
			let res = await http.get('api/Common/index',{
				model:'vippart',
				type:'content',
				mid:'2',
				rows_limit:'16'
			})
			this.dataList = res.data.data.list.data
			this.Totals = res.data.data.list.total
			this.currentPage = res.data.data.list.current_page
		},
		methods: {
			async selectChild1() {
				if (this.keyword == '') {
					alert('请输入内容')
				}
				let res = await http.post('api/Common/index', {
					model:'vippart',
					type:'content',
					mid:'2',
					rows_limit:'16',
					title: this.keyword
				})
				this.dataList = res.data.data.list.data
				this.Totals = res.data.data.list.total
				this.currentPage = res.data.data.list.current_page
			},
			handleSizeChange(val) {},
			async handleCurrentChange(val) {
				let res = await http.post('api/Common/index', {
					model:'vippart',
					type:'content',
					mid:'2',
					rows_limit:'16',
					page:val,
					title: this.keyword
				})
				this.dataList = res.data.data.list.data
				this.Totals = res.data.data.count
				this.currentPage = res.data.data.list.current_page
			}
		}
	}
</script>

<style scoped>
	.centert {
		width: 1200px;
		margin: 0 auto;
	}

	.Bigcoffdetails {
		height: 1200px;
		width: 100%;
	}

	.pub_pub {
		margin-top: 20px;
		border-radius: 0px !important;
		height: 36px;
	}

	.pub_title {
		width: 350px;
		float: left;
	}

	.ctu_::after,
	.pub_title::after {
		content: '';
		display: block;
		clear: both;
	}

	.pub_title>img {
		width: 100%;
		height: 100%;
	}

	.img_logo {
		float: left;
		width: 36px;
		height: 36px;
		overflow: hidden;
	}

	.title_t {
		float: left;
		height: 36px;
		margin-left: 12px;
		font-weight: 600;
		letter-spacing: 3px;
	}

	.imhg_ti {
		height: 12px;
		width: 120px;
		margin-top: -5px;
	}

	.imhg_ti>img {
		width: 100%;
		height: 100%;
	}

	.sm_t {
		height: 26px;
		line-height: 26px;
		font-size: 18px;
		margin-top: 8px;
	}

	.sm_pub {
		float: left;
		margin-left: 12px;
		font-size: 12px;
		color: #5e5d5d;
		cursor: pointer;
	}

	.sy::after,
	.ckgd_dh::after {
		content: '';
		display: block;
		clear: both;
	}

	.ckgd_dh {
		float: left;
		font-size: 12px;
		margin-left: 50px;
	}

	.ckgd_dh>div {
		float: left;
		height: 40px;
		line-height: 42px;
		color: #5e5d5d;
	}


	.name {
		line-height: 43px;
	}

	.sy_img {
		float: left;
		width: 20px;
		height: 20px;
	}
	
	.sy_img>img{
		margin-top: 13px;
		width: 100%;
		height: 100%;
	}
	
	.jt>img{
		margin-top: 10px;
	}

	.sy_title {
		float: left;
		height: 40px;
		line-height: 44px;
		margin-left: 6px;
		color: #5e5d5d;
	}

	.jt {
		width: 12px;
		height: 20px;
		margin-left: 6px;
		margin-right: 6px;
	}
	
	.Bigcosousuo{
		float: left;
		width: 300px;
		height: 36px;
		border: 1px solid #ececec;
		margin-left: 50px;
		background-color: #D7230C;
	}
	
	.Bigcosousuo > input {
		width: 65%;
		height: 34px;
		float: left;
		border: 0px;
		outline: none;
	}
	.Bigcosousuo > div {
		width: 30%;
		height: 36px;
		float: left;
		line-height: 36px;
		font-size: 20px;
		color: #FFF;
		font-weight: 800;
		text-align: center;
	}
	/* 头部结束 */
	.top_bottom{
		width: 100%;
		height: 1150px;
		box-shadow: #6e6e6e 0px 0px 10px;margin-top: 30px;
	}
</style>
